define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/html",
	"csi/property/Widget"
], function(declare, _, html, PropertyWidget) {

	const SIZE_CHART_PATH = "Child:__Parent__/Child:ReviewSizeChart";
	const SUBRANGE_PATH = "Child:SizeChartSubSizeRanges/Index:0";

	return declare(PropertyWidget, {
		/**
		 * @override
		 * Skip certain headings if a composite size range
		 */
		onViewStartBuild() {
			if (this._isCompositeSizeRange()) {
				this.attributeSpecs.remove(true, (spec) => spec.heading.m_path?.indexOf(SUBRANGE_PATH) >= 0);
			}
		},

		_getSizeChartRevision: function() {
			// summary: return SizeChartRevision node
			let node = this.getViewNode();

			if (node?.$Type == "SizeChartReviewRevision") {
				node = this.cacheView.getPathNode(node, SIZE_CHART_PATH);
			}

			return node;
		},

		_isCompositeSizeRange: function() {
			// summary: return if size range is composite
			const node = this._getSizeChartRevision();
			return node?.SizeChartSubSizeRanges.length > 1;
		},

		/**
		 * @override
		 * Ensure have nodes to get to size chart
		 */
		_onRootDependencyPaths(paths) {
			const node = this.getViewNode();

			if (node?.$Type === "SizeChartReviewRevision") {
				paths.push(SIZE_CHART_PATH);
			}

			this.inherited(arguments);
		},

		_postViewDeferred: function(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: insert sub-range view if multiple
			this._deleteViewLayout();
			html.setVisible(this.actionsNode, false);

			if (this._isCompositeSizeRange()) {
				const div = this.getExtraPropertyDiv("propertyViewActions");

				dfds.push(this._insertAndCreateView("SubSizeRanges", this._getSizeChartRevision(), div).then((view) => {
					this.viewLayout = view;
					html.setVisible(this.actionsNode, true);
				}));
			}
		}
	});
});